import { ReportingChannelType } from '../../../../types/reportingChannelType';

export const DEFAULT_REPORTED_CHANNELS = [
    ReportingChannelType.GRAFANA,
    ReportingChannelType.BIG_QUERY,
    ReportingChannelType.MIXPANEL,
];
